import { FontFamily } from '@euler/components/typography';
import { setDefaultConfirmAlertOptions } from '@euler/utils';
import { setDefaultPromptOptions } from '@euler/utils/prompt';
import { ComponentType } from 'react';
import {
  FlatListProps,
  Platform,
  ScrollView,
  ScrollViewProps,
  SectionListProps,
  Text,
  TextProps,
} from 'react-native';
import KeyboardManager from 'react-native-keyboard-manager';
import Toast, { ToastContainer, ToastProps } from 'react-native-root-toast';

(ToastContainer as ComponentType<ToastProps>).defaultProps = {
  ...(ToastContainer as ComponentType<ToastProps>).defaultProps,
  keyboardAvoiding: false,
  position: Toast.positions.CENTER,
  textStyle: {
    fontSize: 12,
    fontFamily: FontFamily.NotoSans.Light,
    lineHeight: 13,
  },
  containerStyle: {
    paddingHorizontal: 10,
    paddingVertical: 8,
    marginBottom: 44,
    backgroundColor: '#111',
    opacity: 0.8,
    borderRadius: 5,
    alignItems: 'center',
    justifyContent: 'center',
  },
  backgroundColor: '#111',
  shadowColor: '#111',
};

setDefaultPromptOptions({
  confirmButtonText: '确定',
  cancelButtonText: '取消',
});

setDefaultConfirmAlertOptions({
  confirmButtonText: '是',
  cancelButtonText: '否',
});

const RNText = Text as ComponentType<TextProps>;

// https://github.com/facebook/react-native/issues/26610
const RNScrollView = ScrollView as ComponentType<ScrollViewProps>;
const RNFlatList = ScrollView as any as ComponentType<FlatListProps<any>>;
const RNSectionList = ScrollView as any as ComponentType<SectionListProps<any>>;

RNScrollView.defaultProps = {
  ...RNScrollView.defaultProps,
  scrollIndicatorInsets: { right: 1, bottom: 1 },
};

RNFlatList.defaultProps = {
  ...RNFlatList.defaultProps,
  scrollIndicatorInsets: { right: 1, bottom: 1 },
};

RNSectionList.defaultProps = {
  ...RNSectionList.defaultProps,
  scrollIndicatorInsets: { right: 1, bottom: 1 },
};

if (RNText.defaultProps) {
  RNText.defaultProps.allowFontScaling = false;
}

if (Platform.OS === 'ios') {
  KeyboardManager.setToolbarDoneBarButtonItemText('确定');
  KeyboardManager.setKeyboardAppearance('light');
}
